import $ from 'jquery';

document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector('.search-toggle');
  const btn = document.querySelector('.search-icon-btn');

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    toggle.classList.toggle('active');
  });

  document.addEventListener('click', function (e) {
    if (!toggle.contains(e.target)) {
      toggle.classList.remove('active');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let input, suggestionBox;

if (window.innerWidth > 920) {
  input = document.querySelector(".product-search-form #search-input");
  suggestionBox = document.querySelector("#search-suggestions.deks");
} else {
  input = document.querySelector(".product-search-formmb #search-input");
  suggestionBox = document.querySelector("#search-suggestions.mb");
}
  let timer;
  input.addEventListener("input", function () {
    
    const query = this.value;
    clearTimeout(timer);

    if (query.length < 2) {
      suggestionBox.style.display = "none";
      return;
    }

    timer = setTimeout(() => {
      console.log("input2");
      fetch(`/wp-json/wp/v2/nieruchomosc?search=${encodeURIComponent(query)}&per_page=5`)
        .then(res => res.json())
        .then(data => {
          if (data.length) {
            const items = data
              .map(item => `<li data-url="${item.link}">${item.title.rendered}</li>`)
              .join("");
            suggestionBox.innerHTML = `<ul>${items}</ul>`;
            suggestionBox.style.display = "block";
          } else {
            suggestionBox.style.display = "none";
          }
        });
    }, 300);
  });

  suggestionBox.addEventListener("click", function (e) {
    if (e.target.tagName === "LI") {
      window.location.href = e.target.getAttribute("data-url");
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.product-search-form');
  form.addEventListener('submit', function () {
    const select = form.querySelector('[name="product_cat"]');
    if (select && select.value === '') {
      select.disabled = true; // nie zostanie wysłany w URL
    }
  });
});